var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303, _rect304, _rect305, _rect306, _rect307, _rect308, _rect309, _rect310, _rect311, _rect312, _rect313, _rect314, _rect315, _rect316, _rect317, _rect318, _rect319, _rect320, _rect321, _rect322, _rect323, _rect324, _rect325, _rect326, _rect327, _rect328, _rect329, _rect330, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgBigDataCube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 701,
    height: 727,
    viewBox: "0 0 701 727",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.112 281.488)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 314.999 322.981)",
    fill: "#20386D",
    stroke: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 314.996 322.534)",
    fill: "url(#paint0_linear_8066_2655)",
    stroke: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.112 364.028)",
    fill: "url(#paint1_linear_8066_2655)",
    stroke: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.054 323.192)",
    fill: "url(#paint2_linear_8066_2655)",
    stroke: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 467.184 328.283)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 396.072 369.777)",
    fill: "#20386D",
    stroke: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 396.069 369.33)",
    fill: "url(#paint3_linear_8066_2655)",
    stroke: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 467.184 410.823)",
    fill: "url(#paint4_linear_8066_2655)",
    stroke: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 396.127 369.988)",
    fill: "url(#paint5_linear_8066_2655)",
    stroke: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 548.257 375.061)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 477.144 416.554)",
    fill: "#20386D",
    stroke: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 477.141 416.107)",
    fill: "url(#paint6_linear_8066_2655)",
    stroke: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 548.257 457.601)",
    fill: "url(#paint7_linear_8066_2655)",
    stroke: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 477.2 416.766)",
    fill: "url(#paint8_linear_8066_2655)",
    stroke: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 305.007 328.283)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 233.894 369.777)",
    fill: "#20386D",
    stroke: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 233.892 369.33)",
    fill: "url(#paint9_linear_8066_2655)",
    stroke: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 305.007 410.823)",
    fill: "url(#paint10_linear_8066_2655)",
    stroke: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 233.95 369.988)",
    fill: "url(#paint11_linear_8066_2655)",
    stroke: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.079 375.078)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 314.967 416.571)",
    fill: "#20386D",
    stroke: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 314.964 416.125)",
    fill: "url(#paint12_linear_8066_2655)",
    stroke: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.08 457.617)",
    fill: "url(#paint13_linear_8066_2655)",
    stroke: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.022 416.784)",
    fill: "url(#paint14_linear_8066_2655)",
    stroke: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 467.152 421.856)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 396.039 463.349)",
    fill: "#20386D",
    stroke: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 396.037 462.903)",
    fill: "url(#paint15_linear_8066_2655)",
    stroke: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 467.152 504.396)",
    fill: "url(#paint16_linear_8066_2655)",
    stroke: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 396.095 463.562)",
    fill: "url(#paint17_linear_8066_2655)",
    stroke: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 223.902 375.095)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 152.789 416.588)",
    fill: "#20386D",
    stroke: "white"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 152.787 416.141)",
    fill: "url(#paint18_linear_8066_2655)",
    stroke: "white"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 223.902 457.634)",
    fill: "url(#paint19_linear_8066_2655)",
    stroke: "white"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 152.845 416.799)",
    fill: "url(#paint20_linear_8066_2655)",
    stroke: "white"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 304.974 421.89)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 233.861 463.383)",
    fill: "#20386D",
    stroke: "white"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 233.858 462.937)",
    fill: "url(#paint21_linear_8066_2655)",
    stroke: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 304.974 504.43)",
    fill: "url(#paint22_linear_8066_2655)",
    stroke: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 233.916 463.595)",
    fill: "url(#paint23_linear_8066_2655)",
    stroke: "white"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.046 468.669)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 314.934 510.162)",
    fill: "#20386D",
    stroke: "white"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 314.931 509.715)",
    fill: "url(#paint24_linear_8066_2655)",
    stroke: "white"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.046 551.209)",
    fill: "url(#paint25_linear_8066_2655)",
    stroke: "white"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 314.989 510.373)",
    fill: "url(#paint26_linear_8066_2655)",
    stroke: "white"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 223.85 468.916)",
    fill: "#334E8A"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 152.737 509.976)",
    fill: "#20386D"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 152.792 509.745)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 223.908 551.239)",
    fill: "url(#paint27_linear_8066_2655)",
    stroke: "white"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 152.85 510.404)",
    fill: "url(#paint28_linear_8066_2655)",
    stroke: "white"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 304.922 515.693)",
    fill: "#334E8A"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 233.81 556.753)",
    fill: "#20386D"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 233.865 556.523)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 304.98 598.017)",
    fill: "url(#paint29_linear_8066_2655)",
    stroke: "white"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 233.923 557.182)",
    fill: "url(#paint30_linear_8066_2655)",
    stroke: "white"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 629.278 422.104)",
    fill: "#334E8A"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 558.165 463.164)",
    fill: "#20386D"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 558.221 462.934)",
    fill: "url(#paint31_linear_8066_2655)",
    stroke: "white"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 629.336 504.427)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 558.279 463.592)",
    fill: "url(#paint32_linear_8066_2655)",
    stroke: "white"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 548.172 468.899)",
    fill: "#334E8A"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 477.059 509.959)",
    fill: "#20386D"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 477.115 509.729)",
    fill: "url(#paint33_linear_8066_2655)",
    stroke: "white"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 548.23 551.221)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 477.173 510.388)",
    fill: "url(#paint34_linear_8066_2655)",
    stroke: "white"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 467.066 515.711)",
    fill: "#334E8A"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 395.953 556.771)",
    fill: "#20386D"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 396.009 556.541)",
    fill: "url(#paint35_linear_8066_2655)",
    stroke: "white"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 467.124 598.034)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 396.067 557.199)",
    fill: "url(#paint36_linear_8066_2655)",
    stroke: "white"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 385.925 562.475)",
    fill: "#334E8A"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 314.812 603.535)",
    fill: "#20386D"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 314.868 603.304)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 385.983 644.798)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 314.926 603.963)",
    fill: "url(#paint37_linear_8066_2655)",
    stroke: "white"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.218 187.944)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 315.105 229.436)",
    fill: "#20386D",
    stroke: "white"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 315.102 228.99)",
    fill: "url(#paint38_linear_8066_2655)",
    stroke: "white"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.218 270.484)",
    fill: "url(#paint39_linear_8066_2655)",
    stroke: "white"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.16 229.649)",
    fill: "url(#paint40_linear_8066_2655)",
    stroke: "white"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 467.29 234.739)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 396.177 276.232)",
    fill: "#20386D",
    stroke: "white"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 396.175 275.785)",
    fill: "url(#paint41_linear_8066_2655)",
    stroke: "white"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 467.29 317.279)",
    fill: "url(#paint42_linear_8066_2655)",
    stroke: "white"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 396.233 276.443)",
    fill: "url(#paint43_linear_8066_2655)",
    stroke: "white"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 548.362 281.517)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 477.249 323.01)",
    fill: "#20386D",
    stroke: "white"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 477.247 322.563)",
    fill: "url(#paint44_linear_8066_2655)",
    stroke: "white"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 548.362 364.057)",
    fill: "url(#paint45_linear_8066_2655)",
    stroke: "white"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 477.305 323.222)",
    fill: "url(#paint46_linear_8066_2655)",
    stroke: "white"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 305.112 234.739)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 233.999 276.232)",
    fill: "#20386D",
    stroke: "white"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 233.997 275.785)",
    fill: "url(#paint47_linear_8066_2655)",
    stroke: "white"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 305.112 317.279)",
    fill: "url(#paint48_linear_8066_2655)",
    stroke: "white"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 234.055 276.443)",
    fill: "url(#paint49_linear_8066_2655)",
    stroke: "white"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.185 281.534)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 315.072 323.027)",
    fill: "#20386D",
    stroke: "white"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 315.07 322.58)",
    fill: "url(#paint50_linear_8066_2655)",
    stroke: "white"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.185 364.073)",
    fill: "url(#paint51_linear_8066_2655)",
    stroke: "white"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.128 323.239)",
    fill: "url(#paint52_linear_8066_2655)",
    stroke: "white"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 467.257 328.312)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 396.144 369.804)",
    fill: "#20386D",
    stroke: "white"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 396.142 369.358)",
    fill: "url(#paint53_linear_8066_2655)",
    stroke: "white"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 467.257 410.851)",
    fill: "url(#paint54_linear_8066_2655)",
    stroke: "white"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 396.2 370.017)",
    fill: "url(#paint55_linear_8066_2655)",
    stroke: "white"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 224.007 281.551)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 152.894 323.044)",
    fill: "#20386D",
    stroke: "white"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 152.892 322.597)",
    fill: "url(#paint56_linear_8066_2655)",
    stroke: "white"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 224.007 364.091)",
    fill: "url(#paint57_linear_8066_2655)",
    stroke: "white"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 152.95 323.256)",
    fill: "url(#paint58_linear_8066_2655)",
    stroke: "white"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 305.079 328.346)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 233.967 369.84)",
    fill: "#20386D",
    stroke: "white"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 233.964 369.393)",
    fill: "url(#paint59_linear_8066_2655)",
    stroke: "white"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 305.08 410.886)",
    fill: "url(#paint60_linear_8066_2655)",
    stroke: "white"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 234.022 370.051)",
    fill: "url(#paint61_linear_8066_2655)",
    stroke: "white"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.152 375.124)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 315.039 416.617)",
    fill: "#20386D",
    stroke: "white"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 315.037 416.171)",
    fill: "url(#paint62_linear_8066_2655)",
    stroke: "white"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.152 457.664)",
    fill: "url(#paint63_linear_8066_2655)",
    stroke: "white"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.095 416.829)",
    fill: "url(#paint64_linear_8066_2655)",
    stroke: "white"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 142.884 328.577)",
    fill: "#334E8A"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 71.771 369.637)",
    fill: "#20386D"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 71.8266 369.407)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 142.942 410.899)",
    fill: "url(#paint65_linear_8066_2655)",
    stroke: "white"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 71.8846 370.065)",
    fill: "url(#paint66_linear_8066_2655)",
    stroke: "white"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 223.956 375.372)",
    fill: "#334E8A"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 152.843 416.432)",
    fill: "#20386D"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 152.898 416.201)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 224.014 457.695)",
    fill: "url(#paint67_linear_8066_2655)",
    stroke: "white"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 152.956 416.86)",
    fill: "url(#paint68_linear_8066_2655)",
    stroke: "white"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 305.028 422.149)",
    fill: "#334E8A"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 233.915 463.209)",
    fill: "#20386D"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 233.971 462.979)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 305.086 504.473)",
    fill: "url(#paint69_linear_8066_2655)",
    stroke: "white"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 234.029 463.638)",
    fill: "url(#paint70_linear_8066_2655)",
    stroke: "white"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 629.383 328.56)",
    fill: "#334E8A"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 558.271 369.62)",
    fill: "#20386D"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 558.326 369.389)",
    fill: "url(#paint71_linear_8066_2655)",
    stroke: "white"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 629.441 410.883)",
    fill: "url(#paint72_linear_8066_2655)",
    stroke: "white"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 558.384 370.048)",
    fill: "url(#paint73_linear_8066_2655)",
    stroke: "white"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 548.277 375.354)",
    fill: "#334E8A"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 477.165 416.414)",
    fill: "#20386D"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 477.22 416.184)",
    fill: "url(#paint74_linear_8066_2655)",
    stroke: "white"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 548.335 457.677)",
    fill: "url(#paint75_linear_8066_2655)",
    stroke: "white"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 477.278 416.843)",
    fill: "url(#paint76_linear_8066_2655)",
    stroke: "white"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.03 468.931)",
    fill: "#334E8A"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 314.918 509.991)",
    fill: "#20386D"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 314.974 509.761)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.088 551.254)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.032 510.419)",
    fill: "url(#paint77_linear_8066_2655)",
    stroke: "white"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 71.8744 193.735)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 0.761638 235.227)",
    fill: "#20386D",
    stroke: "white"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 0.759169 234.781)",
    fill: "url(#paint78_linear_8066_2655)",
    stroke: "white"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 71.8744 276.274)",
    fill: "url(#paint79_linear_8066_2655)",
    stroke: "white"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 0.817185 235.44)",
    fill: "url(#paint80_linear_8066_2655)",
    stroke: "white"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.21 94.3528)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 315.097 135.845)",
    fill: "#20386D",
    stroke: "white"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 315.095 135.399)",
    fill: "url(#paint81_linear_8066_2655)",
    stroke: "white"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.21 176.893)",
    fill: "url(#paint82_linear_8066_2655)",
    stroke: "white"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.153 136.058)",
    fill: "url(#paint83_linear_8066_2655)",
    stroke: "white"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 467.283 141.148)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 396.17 182.64)",
    fill: "#20386D",
    stroke: "white"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 396.167 182.195)",
    fill: "url(#paint84_linear_8066_2655)",
    stroke: "white"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 467.283 223.688)",
    fill: "url(#paint85_linear_8066_2655)",
    stroke: "white"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 396.225 182.853)",
    fill: "url(#paint86_linear_8066_2655)",
    stroke: "white"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 548.355 187.926)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 477.243 229.419)",
    fill: "#20386D",
    stroke: "white"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 477.24 228.972)",
    fill: "url(#paint87_linear_8066_2655)",
    stroke: "white"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 548.355 270.466)",
    fill: "url(#paint88_linear_8066_2655)",
    stroke: "white"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 477.298 229.63)",
    fill: "url(#paint89_linear_8066_2655)",
    stroke: "white"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 305.105 141.148)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 233.992 182.64)",
    fill: "#20386D",
    stroke: "white"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 233.99 182.195)",
    fill: "url(#paint90_linear_8066_2655)",
    stroke: "white"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 305.105 223.688)",
    fill: "url(#paint91_linear_8066_2655)",
    stroke: "white"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 234.048 182.853)",
    fill: "url(#paint92_linear_8066_2655)",
    stroke: "white"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.178 187.944)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 315.065 229.436)",
    fill: "#20386D",
    stroke: "white"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 315.062 228.99)",
    fill: "url(#paint93_linear_8066_2655)",
    stroke: "white"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.178 270.483)",
    fill: "url(#paint94_linear_8066_2655)",
    stroke: "white"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.12 229.649)",
    fill: "url(#paint95_linear_8066_2655)",
    stroke: "white"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 467.249 234.721)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 396.137 276.214)",
    fill: "#20386D",
    stroke: "white"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 396.134 275.767)",
    fill: "url(#paint96_linear_8066_2655)",
    stroke: "white"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 467.249 317.26)",
    fill: "url(#paint97_linear_8066_2655)",
    stroke: "white"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 396.192 276.426)",
    fill: "url(#paint98_linear_8066_2655)",
    stroke: "white"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 224 187.96)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 152.887 229.453)",
    fill: "#20386D",
    stroke: "white"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 152.885 229.006)",
    fill: "url(#paint99_linear_8066_2655)",
    stroke: "white"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 224 270.5)",
    fill: "url(#paint100_linear_8066_2655)",
    stroke: "white"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 152.943 229.664)",
    fill: "url(#paint101_linear_8066_2655)",
    stroke: "white"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 305.072 234.755)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 233.959 276.248)",
    fill: "#20386D",
    stroke: "white"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 233.957 275.802)",
    fill: "url(#paint102_linear_8066_2655)",
    stroke: "white"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 305.072 317.295)",
    fill: "url(#paint103_linear_8066_2655)",
    stroke: "white"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 234.015 276.46)",
    fill: "url(#paint104_linear_8066_2655)",
    stroke: "white"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.144 281.533)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 315.032 323.027)",
    fill: "#20386D",
    stroke: "white"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 315.029 322.58)",
    fill: "url(#paint105_linear_8066_2655)",
    stroke: "white"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.144 364.073)",
    fill: "url(#paint106_linear_8066_2655)",
    stroke: "white"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.087 323.238)",
    fill: "url(#paint107_linear_8066_2655)",
    stroke: "white"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 223.948 281.781)",
    fill: "#334E8A"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 152.835 322.841)",
    fill: "#20386D"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 152.891 322.611)",
    fill: "url(#paint108_linear_8066_2655)",
    stroke: "white"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 224.006 364.104)",
    fill: "url(#paint109_linear_8066_2655)",
    stroke: "white"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 152.949 323.269)",
    fill: "url(#paint110_linear_8066_2655)",
    stroke: "white"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 629.376 234.969)",
    fill: "#334E8A"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 558.263 276.029)",
    fill: "#20386D"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 558.319 275.799)",
    fill: "url(#paint111_linear_8066_2655)",
    stroke: "white"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 629.434 317.292)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 558.377 276.457)",
    fill: "url(#paint112_linear_8066_2655)",
    stroke: "white"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 467.164 328.576)",
    fill: "#334E8A"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 396.051 369.636)",
    fill: "#20386D"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 396.107 369.406)",
    fill: "url(#paint113_linear_8066_2655)",
    stroke: "white"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 467.222 410.899)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 396.165 370.064)",
    fill: "url(#paint114_linear_8066_2655)",
    stroke: "white"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.023 375.34)",
    fill: "#334E8A"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 314.911 416.4)",
    fill: "#20386D"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 314.966 416.17)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.081 457.663)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.024 416.828)",
    fill: "url(#paint115_linear_8066_2655)",
    stroke: "white"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.212 0.967773)",
    fill: "#334E8A"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 315.1 42.0283)",
    fill: "#20386D"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 315.155 41.7971)",
    fill: "url(#paint116_linear_8066_2655)",
    stroke: "white"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.27 83.2917)",
    fill: "url(#paint117_linear_8066_2655)",
    stroke: "white"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.213 42.4564)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 467.285 47.7627)",
    fill: "#334E8A"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 396.172 88.8223)",
    fill: "#20386D"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 396.228 88.593)",
    fill: "url(#paint118_linear_8066_2655)",
    stroke: "white"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 467.343 130.087)",
    fill: "url(#paint119_linear_8066_2655)",
    stroke: "white"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 396.286 89.2514)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 548.357 94.542)",
    fill: "#334E8A"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 477.245 135.603)",
    fill: "#20386D"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 477.3 135.372)",
    fill: "url(#paint120_linear_8066_2655)",
    stroke: "white"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 548.415 176.866)",
    fill: "url(#paint121_linear_8066_2655)",
    stroke: "white"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 477.358 136.031)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 305.107 47.7627)",
    fill: "#334E8A"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 233.995 88.8223)",
    fill: "#20386D"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 234.05 88.593)",
    fill: "url(#paint122_linear_8066_2655)",
    stroke: "white"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 305.165 130.087)",
    fill: "url(#paint123_linear_8066_2655)",
    stroke: "white"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 234.108 89.2514)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.18 94.5596)",
    fill: "#334E8A"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 315.067 135.62)",
    fill: "#20386D"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 315.122 135.389)",
    fill: "url(#paint124_linear_8066_2655)",
    stroke: "white"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.238 176.883)",
    fill: "url(#paint125_linear_8066_2655)",
    stroke: "white"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.18 136.048)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 467.252 141.337)",
    fill: "#334E8A"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 396.139 182.396)",
    fill: "#20386D"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 396.195 182.167)",
    fill: "url(#paint126_linear_8066_2655)",
    stroke: "white"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 467.31 223.661)",
    fill: "url(#paint127_linear_8066_2655)",
    stroke: "white"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 396.253 182.826)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 224.003 70.7852)",
    fill: "#334E8A"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 152.89 111.846)",
    fill: "#20386D"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 152.946 111.615)",
    fill: "url(#paint128_linear_8066_2655)",
    stroke: "white"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 224.061 153.109)",
    fill: "url(#paint129_linear_8066_2655)",
    stroke: "white"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 153.004 112.274)",
    fill: "url(#paint130_linear_8066_2655)",
    stroke: "white"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 305.074 141.371)",
    fill: "#334E8A"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 233.961 182.432)",
    fill: "#20386D"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 234.017 182.201)",
    fill: "url(#paint131_linear_8066_2655)",
    stroke: "white"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 305.132 223.695)",
    fill: "url(#paint132_linear_8066_2655)",
    stroke: "white"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 234.075 182.86)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.147 188.148)",
    fill: "#334E8A"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 315.034 229.208)",
    fill: "#20386D"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 315.09 228.978)",
    fill: "url(#paint133_linear_8066_2655)",
    stroke: "white"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.205 270.472)",
    fill: "url(#paint134_linear_8066_2655)",
    stroke: "white"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.148 229.637)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 142.931 141.424)",
    fill: "#334E8A"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 71.8184 182.484)",
    fill: "#20386D"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 71.8739 182.254)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 142.989 223.748)",
    fill: "url(#paint135_linear_8066_2655)",
    stroke: "white"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 71.9319 182.912)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 224.003 188.219)",
    fill: "#334E8A"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 152.89 229.279)",
    fill: "#20386D"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 152.946 229.049)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 224.061 270.542)",
    fill: "url(#paint136_linear_8066_2655)",
    stroke: "white"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 153.004 229.707)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 305.075 234.997)",
    fill: "#334E8A"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 233.962 276.057)",
    fill: "#20386D"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 234.018 275.827)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 305.133 317.321)",
    fill: "url(#paint137_linear_8066_2655)",
    stroke: "white"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 234.076 276.485)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 629.43 141.39)",
    fill: "#334E8A"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 558.317 182.45)",
    fill: "#20386D"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 558.372 182.22)",
    fill: "url(#paint138_linear_8066_2655)",
    stroke: "white"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 629.488 223.714)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 558.43 182.878)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 467.218 234.997)",
    fill: "#334E8A"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 396.105 276.057)",
    fill: "#20386D"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 396.161 275.827)",
    fill: "url(#paint139_linear_8066_2655)",
    stroke: "white"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 467.276 317.321)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 396.219 276.485)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 386.12 281.779)",
    fill: "#334E8A"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 315.007 322.839)",
    fill: "#20386D"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 315.063 322.609)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 386.178 364.102)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 315.121 323.268)",
    fill: "#E6F1FF",
    stroke: "white"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 3.27705,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 71.6597 545.276)",
    fill: "#334E8A"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 3.27705,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 0.547363 586.336)",
    fill: "#20386D"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.1151,
    transform: "matrix(0.866042 0.499972 -0.866042 0.499972 71.6597 548.549)",
    fill: "#AAAAAA"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 3.27705,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 0.544922 586.323)",
    fill: "url(#paint140_linear_8066_2655)"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 3.27705,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 71.6597 627.382)",
    fill: "url(#paint141_linear_8066_2655)"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 0.544922 586.332)",
    fill: "#1B1E59"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 71.7177 462.937)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 0.605388 504.43)",
    fill: "#20386D",
    stroke: "white"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 0.602919 503.983)",
    fill: "url(#paint142_linear_8066_2655)",
    stroke: "white"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 71.7177 545.476)",
    fill: "url(#paint143_linear_8066_2655)",
    stroke: "white"
  })), _rect304 || (_rect304 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 0.660935 504.642)",
    fill: "url(#paint144_linear_8066_2655)",
    stroke: "white"
  })), _rect305 || (_rect305 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 234.018 369.346)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect306 || (_rect306 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 162.906 410.84)",
    fill: "#20386D",
    stroke: "white"
  })), _rect307 || (_rect307 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 162.903 410.393)",
    fill: "url(#paint145_linear_8066_2655)",
    stroke: "white"
  })), _rect308 || (_rect308 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 234.018 451.886)",
    fill: "url(#paint146_linear_8066_2655)",
    stroke: "white"
  })), _rect309 || (_rect309 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 162.961 411.051)",
    fill: "url(#paint147_linear_8066_2655)",
    stroke: "white"
  })), _rect310 || (_rect310 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 538.372 463.014)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect311 || (_rect311 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 467.259 504.508)",
    fill: "#20386D",
    stroke: "white"
  })), _rect312 || (_rect312 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 467.257 504.061)",
    fill: "url(#paint148_linear_8066_2655)",
    stroke: "white"
  })), _rect313 || (_rect313 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 538.372 545.553)",
    fill: "url(#paint149_linear_8066_2655)",
    stroke: "white"
  })), _rect314 || (_rect314 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 467.315 504.72)",
    fill: "url(#paint150_linear_8066_2655)",
    stroke: "white"
  })), _rect315 || (_rect315 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 3.27705,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 619.438 404.873)",
    fill: "#334E8A"
  })), _rect316 || (_rect316 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 3.27705,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 548.326 445.933)",
    fill: "#20386D"
  })), _rect317 || (_rect317 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.1151,
    transform: "matrix(0.866042 0.499972 -0.866042 0.499972 619.438 408.146)",
    fill: "#AAAAAA"
  })), _rect318 || (_rect318 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 3.27705,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 548.323 445.919)",
    fill: "url(#paint151_linear_8066_2655)"
  })), _rect319 || (_rect319 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 3.27705,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 619.438 486.979)",
    fill: "url(#paint152_linear_8066_2655)"
  })), _rect320 || (_rect320 = /*#__PURE__*/React.createElement("rect", {
    width: 82.1151,
    height: 82.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 548.323 445.928)",
    fill: "#1B1E59"
  })), _rect321 || (_rect321 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 619.496 322.534)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect322 || (_rect322 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 548.384 364.027)",
    fill: "#20386D",
    stroke: "white"
  })), _rect323 || (_rect323 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 548.381 363.58)",
    fill: "url(#paint153_linear_8066_2655)",
    stroke: "white"
  })), _rect324 || (_rect324 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 619.497 405.073)",
    fill: "url(#paint154_linear_8066_2655)",
    stroke: "white"
  })), _rect325 || (_rect325 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 548.439 364.239)",
    fill: "url(#paint155_linear_8066_2655)",
    stroke: "white"
  })), _rect326 || (_rect326 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 548.415 105.816)",
    fill: "#334E8A",
    stroke: "white"
  })), _rect327 || (_rect327 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 477.303 147.309)",
    fill: "#20386D",
    stroke: "white"
  })), _rect328 || (_rect328 = /*#__PURE__*/React.createElement("rect", {
    x: 0.433021,
    y: 0.750014,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 0.500027 3.18351e-05 1 477.3 146.863)",
    fill: "url(#paint156_linear_8066_2655)",
    stroke: "white"
  })), _rect329 || (_rect329 = /*#__PURE__*/React.createElement("rect", {
    x: 0.432989,
    y: 0.249986,
    width: 81.1151,
    height: 81.115,
    transform: "matrix(0.86601 -0.500027 -3.18351e-05 1 548.415 188.356)",
    fill: "url(#paint157_linear_8066_2655)",
    stroke: "white"
  })), _rect330 || (_rect330 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866042,
    width: 81.1151,
    height: 81.1151,
    transform: "matrix(0.866042 -0.499972 0.866042 0.499972 477.358 147.521)",
    fill: "url(#paint158_linear_8066_2655)",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_8066_2655",
    x1: 64.7561,
    y1: 17.3461,
    x2: 26.3128,
    y2: 71.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_8066_2655",
    x1: 64.7561,
    y1: 17.3461,
    x2: 26.3128,
    y2: 71.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_8066_2655",
    x1: 81.7677,
    y1: 0.00000576987,
    x2: -16.317,
    y2: 33.9027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_8066_2655",
    x1: 81.7677,
    y1: 0.00000576987,
    x2: -16.317,
    y2: 33.9027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_8066_2655",
    x1: 81.7677,
    y1: 0.00000576987,
    x2: -16.317,
    y2: 33.9027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_8066_2655",
    x1: 64.7561,
    y1: 17.3461,
    x2: 26.3128,
    y2: 71.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_8066_2655",
    x1: 64.7561,
    y1: 17.3461,
    x2: 26.3128,
    y2: 71.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_8066_2655",
    x1: 64.7561,
    y1: 17.3461,
    x2: 26.3128,
    y2: 71.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_8066_2655",
    x1: 81.7677,
    y1: 0.00000576987,
    x2: -16.317,
    y2: 33.9027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_8066_2655",
    x1: 64.6948,
    y1: 17.2236,
    x2: 26.2654,
    y2: 71.1901,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_8066_2655",
    x1: 81.7677,
    y1: 0.00000576987,
    x2: -16.317,
    y2: 33.9027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_8066_2655",
    x1: 64.826,
    y1: 17.4859,
    x2: 11.0068,
    y2: 55.8057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_8066_2655",
    x1: 82.2648,
    y1: 0.00000352174,
    x2: -16.4627,
    y2: 32.3867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_8066_2655",
    x1: 64.7561,
    y1: 17.3461,
    x2: 26.3128,
    y2: 71.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_8066_2655",
    x1: 81.7677,
    y1: 0.00000576987,
    x2: -16.317,
    y2: 33.9027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_8066_2655",
    x1: 81.7677,
    y1: 0.00000576987,
    x2: -16.317,
    y2: 33.9027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#326AE0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EDF0F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08FFA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_8066_2655",
    x1: 81.8662,
    y1: -6.82898e-7,
    x2: -16.3485,
    y2: 33.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_8066_2655",
    x1: 64.4539,
    y1: 16.7418,
    x2: 26.0525,
    y2: 71.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_8066_2655",
    x1: 81.8662,
    y1: -6.82898e-7,
    x2: -16.3485,
    y2: 33.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_8066_2655",
    x1: 64.4539,
    y1: 16.7418,
    x2: 26.0525,
    y2: 71.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_8066_2655",
    x1: 81.8662,
    y1: -6.82898e-7,
    x2: -16.3485,
    y2: 33.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_8066_2655",
    x1: 64.4539,
    y1: 16.7418,
    x2: 26.0525,
    y2: 71.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_8066_2655",
    x1: 81.8662,
    y1: -6.82898e-7,
    x2: -16.3485,
    y2: 33.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_8066_2655",
    x1: 64.4539,
    y1: 16.7418,
    x2: 26.0525,
    y2: 71.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_8066_2655",
    x1: 81.8662,
    y1: -6.82898e-7,
    x2: -16.3485,
    y2: 33.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_8066_2655",
    x1: 64.4539,
    y1: 16.7418,
    x2: 26.0525,
    y2: 71.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_8066_2655",
    x1: 81.8662,
    y1: -6.82898e-7,
    x2: -16.3485,
    y2: 33.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_8066_2655",
    x1: 64.4539,
    y1: 16.7418,
    x2: 26.0525,
    y2: 71.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_8066_2655",
    x1: 81.8662,
    y1: -6.82898e-7,
    x2: -16.3485,
    y2: 33.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_8066_2655",
    x1: 64.4539,
    y1: 16.7418,
    x2: 26.0525,
    y2: 71.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_8066_2655",
    x1: 41.0575,
    y1: 0,
    x2: 41.0575,
    y2: 82.1151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_8066_2655",
    x1: 81.8662,
    y1: -6.82898e-7,
    x2: -16.3485,
    y2: 33.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_8066_2655",
    x1: 64.4539,
    y1: 16.7418,
    x2: 26.0525,
    y2: 71.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_8066_2655",
    x1: 81.8662,
    y1: -6.82898e-7,
    x2: -16.3485,
    y2: 33.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_8066_2655",
    x1: 64.4539,
    y1: 16.7418,
    x2: 26.0525,
    y2: 71.2815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_8066_2655",
    x1: 64.7561,
    y1: 17.3461,
    x2: 26.3128,
    y2: 71.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_8066_2655",
    x1: 64.7561,
    y1: 17.3461,
    x2: 26.3128,
    y2: 71.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_8066_2655",
    x1: 64.7561,
    y1: 17.3461,
    x2: 26.3128,
    y2: 71.1647,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_8066_2655",
    x1: 81.8662,
    y1: -6.82898e-7,
    x2: -16.3485,
    y2: 33.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_8066_2655",
    x1: 81.8662,
    y1: -6.82898e-7,
    x2: -16.3485,
    y2: 33.6005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_8066_2655",
    x1: 82.1151,
    y1: 1.63852,
    x2: -6.99515e-8,
    y2: 1.63852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20386D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#334E8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_8066_2655",
    x1: 0.00000252222,
    y1: 1.63852,
    x2: 82.1151,
    y2: 1.63852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20386D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#334E8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_8066_2655",
    x1: 82.1151,
    y1: 1.63852,
    x2: -6.99515e-8,
    y2: 1.63852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20386D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#334E8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint152_linear_8066_2655",
    x1: 0.00000252222,
    y1: 1.63852,
    x2: 82.1151,
    y2: 1.63852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#20386D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#334E8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint153_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint154_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint155_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint156_linear_8066_2655",
    x1: 82.4521,
    y1: -0.00000113554,
    x2: 48.3273,
    y2: 98.9054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#0083F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D47B0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint157_linear_8066_2655",
    x1: 64.9592,
    y1: 17.7524,
    x2: 26.4968,
    y2: 71.0976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07DBCA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint158_linear_8066_2655",
    x1: 41.2214,
    y1: 0.00000306156,
    x2: 80.4715,
    y2: 52.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08FFA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF0F7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgBigDataCube);
export default __webpack_public_path__ + "static/media/Img_BigDataCube.3d9ccfaed51f84fb978ea03821ea63bb.svg";
export { ForwardRef as ReactComponent };